import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {AppConfig} from '../../app.config';

@Injectable()
export class LearnCategoryService {
  constructor(private http: HttpClient, private api: AppConfig) {
  }

  getLearnCategories() {
    return this.http.get(this.api.baseUrl + '/learnCategory/learnCategories', this.api.jsonTokenHeaders);
  }

  getLearnCategoryById(id) {
    return this.http.get(this.api.baseUrl + '/learnCategory/learnCategory?id=' + id , this.api.jsonTokenHeaders);
  }

  deleteLearnCategory(id) {
    return this.http.delete(this.api.baseUrl + '/learnCategory/deleteLearnCategory?id=' + id , this.api.jsonTokenHeaders);
  }

  addLearnCategory(data) {
    return this.http.post(this.api.baseUrl + '/learnCategory/addLearnCategory' , data , this.api.formDataHeaders);
  }
}
